export default __webpack_public_path__ + "static/media/lock.e385934e.png";